import { configureStore } from '@reduxjs/toolkit';
import LangSlice from './slices/LangSlice';
import MenSlice from './slices/MenuSlice';


const Store = configureStore({
	reducer:{'language':LangSlice, 'MenuPH': MenSlice}
});

export default Store;